import { apiGet, apiPost } from "@redriver/cinnamon";

const NAMESPACE = "RESET_PASSWORD";
const ActionTypes = {
  VerifyResetPasswordToken: `${NAMESPACE}/VERIFY_TOKEN`,
  SetupPassword: `${NAMESPACE}/SETUP_PASSWORD`,
};

export const verifyResetToken = (token) =>
  apiGet(
    ActionTypes.VerifyResetPasswordToken,
    `resort-reps-auth/reset-tokens/${token}`,
    null,
    {
      auth: false,
    }
  );

export const setupPassword = ({ newPassword }, token) =>
  apiPost(
    ActionTypes.SetupPassword,
    `resort-reps-auth/reset-tokens/${token}`,
    { newPassword },
    { auth: false }
  );
